import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OnboardingService {
    /**
     * Initiate Self Onboarding
     * Create onboarding request doc
     * @param requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    static initiateSelfOnboardingOnboardingInitiatePost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/onboarding/initiate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Initiate Selenoid Login
     * Initiate background selenoid login
     * @param onboardingId
     * @returns any Successful Response
     * @throws ApiError
     */
    static initiateSelenoidLoginInitiateLoginPost(onboardingId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/initiate/login',
            query: {
                'onboarding_id': onboardingId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Check Username Marketplace Link
     * Check and fetch marketplace password reset or account setup link
     * @param username
     * @param platform
     * @returns any Successful Response
     * @throws ApiError
     */
    static checkUsernameMarketplaceLinkMarketplacePasswordResetLinkGet(username, platform) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/marketplace/password_reset_link',
            query: {
                'username': username,
                'platform': platform,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Mailslurp Inbox
     * Fetch and return the list of email from the current inbox
     * @param emailId
     * @param page
     * @returns any Successful Response
     * @throws ApiError
     */
    static getMailslurpInboxMailslurpEmailsGet(emailId, page) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mailslurp/emails',
            query: {
                'email_id': emailId,
                'page': page,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Last Otp From Mailslurp
     * Fetch last otp of the given username and platform
     * @param platform
     * @param emailId
     * @returns any Successful Response
     * @throws ApiError
     */
    static getLastOtpFromMailslurpLastOtpGet(platform, emailId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/last/otp',
            query: {
                'platform': platform,
                'email_id': emailId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Backup Credential
     * Add backup creds to postgres
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static addBackupCredentialBackupCredPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backup-cred',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
